import type { WidgetType } from '@/lib/analytics/widget/widget.type';
import { SIZE_FULL } from '@/lib/gridElements/size';

import { MediasWidget } from '@/components/pages/analyze/widget/MediasWidget';

export const mostEngagingVideosConfig: WidgetType<typeof MediasWidget> = {
    title: 'chart.youtube.widget_most_engaging_videos',
    id: 'widget_most_engaging_posts',
    noSortTypesSelect: true,
    size: SIZE_FULL,
    sortFields: ['created', 'likes', 'dislikes', 'comments', 'shares', 'views'],
    type: 'widget',
    element: MediasWidget
};
